import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ch_typography = _resolveComponent("ch-typography")!
  const _component_ch_dropdown = _resolveComponent("ch-dropdown")!
  const _component_CourseView = _resolveComponent("CourseView")!
  const _component_slide = _resolveComponent("slide")!
  const _component_navigation = _resolveComponent("navigation")!
  const _component_carousel = _resolveComponent("carousel")!
  const _component_ch_loader = _resolveComponent("ch-loader")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col mb-6 text-left md:items-center md:!flex-row md:mb-8", !_ctx.courses.length ? '!mb-0' : ''])
        }, [
          _createVNode(_component_ch_typography, {
            class: "flex-5 mb-4 md:mb-0",
            variant: _ctx.isDesktop || _ctx.isMediumDesktop ? 'Untitled20Medium' : 'Untitled18Medium',
            color: "white",
            asTag: "h1",
            innerHTML: _ctx.title
          }, null, 8, ["variant", "innerHTML"]),
          (_ctx.courses.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_ch_dropdown, {
                  class: "dropdown-courses",
                  onSelect: _ctx.setOption,
                  label: _ctx.t('home.courses.show-courses'),
                  options: _ctx.options
                }, null, 8, ["onSelect", "label", "options"])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        (!_ctx.reloadCourses)
          ? (_openBlock(), _createBlock(_component_carousel, {
              "snap-align": 'start',
              "mouse-drag": false,
              "items-to-show": _ctx.option === 'in-progress' ? 1 : _ctx.isDesktop ? 2 : 1,
              class: _normalizeClass(["!text-left !z-0", { 'carousel--alt': _ctx.isDesktop && _ctx.option !== 'in-progress' }]),
              key: _ctx.carouselKey
            }, {
              addons: _withCtx(() => [
                _createVNode(_component_navigation)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCourses, (course) => {
                  return (_openBlock(), _createBlock(_component_slide, {
                    key: course.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CourseView, { course: course }, null, 8, ["course"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["items-to-show", "class"]))
          : (_openBlock(), _createBlock(_component_ch_loader, { key: 1 }))
      ]))
    : (_openBlock(), _createBlock(_component_ch_loader, { key: 1 }))
}